export const verboseLogger = {
  trace(...args: unknown[]) {
    console.trace('[Orion]', ...args);
  },
  info(...args: unknown[]) {
    console.info('[Orion]', ...args);
  },
  debug(...args: unknown[]) {
    console.debug('[Orion]', ...args);
  },
  warn(...args: unknown[]) {
    console.warn('[Orion]', ...args);
  },
  error(...args: unknown[]) {
    console.error('[Orion]', ...args);
  },
  fatal(...args: unknown[]) {
    console.error('[Orion]', ...args);
  },
};

export const emptyLogger = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  trace() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  info() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  debug() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  warn() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  error() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  fatal() {},
};
